<template>
  <v-row no-gutters class="files-upload-progress-box" v-if="filesUploadsProgressArray.length > 0">
    <v-col cols="12">
      <v-row no-gutters class="files-upload-progress-box-header" align="center">
        <v-col cols="8" class="files-upload-progress-box-header-text px-3">{{ headerText }}</v-col>
        <v-spacer />
        <v-col cols="1" class="mx-2">
          <v-icon color="white" size="30" @click="filesVisible = !filesVisible">
            {{ filesVisible ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
          </v-icon>
        </v-col>
        <v-col cols="1" class="mx-2">
          <v-icon color="white" @click="isUploading ? (isCloseConfirmVisible = true) : close()">mdi-close</v-icon>
        </v-col>
      </v-row>
      <template v-if="filesVisible">
        <v-row
          no-gutters
          class="files-upload-progress-list-element"
          v-for="(file, idx) of filesUploadsProgressArray"
          :key="idx"
          align="center"
        >
          <v-col cols="1">
            <v-icon>mdi-paperclip</v-icon>
          </v-col>
          <v-col
            cols="9"
            :class="{ 'error--text': file.progress == '104' }"
            :title="file.progress == '104' ? file.error : ''"
          >
            {{ `${file.name}` }}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-progress-circular
              @mouseover="progressHoverId = file.id"
              @mouseout="progressHoverId = null"
              @click="cancelFileProgress(file.id)"
              :rotate="360"
              :value="file.progress"
              color="primary"
              size="50"
              v-if="file.progress <= 100"
              :style="{ cursor: progressHoverId === file.id ? 'pointer' : 'normal' }"
              title="Anuluj przesyłanie"
            >
              <template v-if="progressHoverId === file.id">
                <v-icon color="error">mdi-close</v-icon>
              </template>
              <template v-else>
                {{ `${file.progress}%` }}
              </template>
            </v-progress-circular>
            <v-icon v-else class="mr-3" color="success" @click="deleteFileProgress(file.id)">mdi-check</v-icon>
          </v-col>
        </v-row>
      </template>
    </v-col>
    <ConfirmDialog :dialog="isCloseConfirmVisible" @success="close()" @cancel="isCloseConfirmVisible = false">
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.closeFilesUpload`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`dialog.content.closeFilesUpload`) }}</p>
      </template>
    </ConfirmDialog>
  </v-row>
</template>
<script>
export default {
  components: {
    ConfirmDialog: () => import('@/components/ConfirmDialog')
  },
  computed: {
    filesUploadsProgress() {
      return this.$store.getters.getFilesUploadsProgress;
    },
    filesUploadsProgressArray() {
      return Object.values(this.filesUploadsProgress);
    },
    headerText() {
      if (this.isUploading) {
        const uploadingLength = this.filesUploadsProgressArray.filter(file => file.progress <= 100).length;
        return this.$i18n.t('offer.attachments.uploadingXFiles', { length: uploadingLength });
      } else {
        const uploadedLength = this.filesUploadsProgressArray.filter(file => file.progress == '101').length;
        return this.$i18n.t('offer.attachments.uploadedXFiles', { length: uploadedLength });
      }
    },
    isUploading() {
      return this.filesUploadsProgressArray.find(file => file.progress <= 100) ? true : false;
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  data: () => ({
    filesVisible: false,
    isCloseConfirmVisible: false,
    progressHoverId: null
  }),
  methods: {
    cancelFileProgress(id) {
      this.$store.commit('cancelFileUploadProgress', id);
    },
    close() {
      for (const file of this.filesUploadsProgressArray) {
        if (file.progress <= 100) {
          this.cancelFileProgress(file.id);
        }
        this.deleteFileProgress(file.id);
      }
      this.isCloseConfirmVisible = false;
    },
    deleteFileProgress(id) {
      this.$store.commit('deleteFileUploadProgress', id);
    },
    uploadFile(payload) {
      this.$store.dispatch('postFile', payload).then(r => {
        if (!r) {
          return;
        } else if (r.msg) {
          this.$root.$emit('showSnackbar', r.msg);
        } else if (r.status === 200 || r.status === 201) {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.attachments.uploadedSucc'));
          this.$root.$emit('addedItem', {
            id: r.data.files,
            filepath: `/cbre3/uploads/${payload.progressInfo.name}`,
            entity_type: payload.progressInfo.entityType,
            entity_id: payload.progressInfo.entityId,
            pl: payload.progressInfo.pl,
            en: payload.progressInfo.en,
            created_at: payload.progressInfo.timeStamp,
            created_by: this.user
          });
        } else if (r.status >= 400) {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.attachments.uploadedError'));
        }
      });
    }
  },
  created() {
    this.$root.$off('uploadFile');
    this.$root.$on('uploadFile', this.uploadFile);
  }
};
</script>
<style lang="scss" scoped>
.files-upload-progress-box {
  width: 350px;
  position: absolute;
  bottom: 3px;
  left: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  filter: drop-shadow(0px -2px 6px rgba(0, 0, 0, 0.15)), drop-shadow(4px 2px 6px rgba(0, 0, 0, 0.15));
  border-radius: 4px 0px 0px 0px;
  z-index: 5;
}
.files-upload-progress-box-header {
  color: white;
  background-color: var(--v-primary-base);
  height: 45px;
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.15), 4px 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 4px 4px 0px 0px;
}
.files-upload-progress-box-header-text {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
}
.files-upload-progress-list-element {
  background-color: white;
  height: 64px;
}
</style>